// localizeServerMessage — يترجم رسائل أخطاء الخادم الشائعة إلى لغة المستخدم (3.4.4).
// الخادم يردّ رسائل إنجليزية/عربية/أكواد ثابتة؛ هنا نُسقطها على مفاتيح server.* عبر
// i18n singleton (لا يحتاج React context). أي رسالة غير معروفة تُعاد كما هي بلا تغيير
// (لا انحدار). يُستدعى مركزيًّا في api.js فيستفيد كل موضع يقرأ data.message تلقائيًّا.
import i18n from '../i18n';

// raw (إنجليزي | عربي | كود) → مفتاح الترجمة. عدّة صيغ قد تُسقَط على مفتاح واحد.
const MAP = {
  'Server error': 'server.server_error',
  'Internal server error': 'server.server_error',
  'Database error': 'server.database_error',
  DB_ERROR: 'server.database_error',
  Updated: 'server.updated',
  Saved: 'server.saved',
  Deleted: 'server.deleted',
  'Deleted safely': 'server.deleted_safely',
  'not found': 'server.not_found',
  NOT_FOUND: 'server.not_found',
  'Record not found': 'server.record_not_found',
  'Horse not found': 'server.horse_not_found',
  'الخيل غير موجود': 'server.horse_not_found',
  'Group not found': 'server.group_not_found',
  'Permission not found': 'server.permission_not_found',
  'Case not found': 'server.case_not_found',
  'Entry was not found': 'server.entry_not_found',
  'This page is no longer managed.': 'server.page_not_managed',
  'Failed to fetch horses': 'server.failed_fetch_horses',
  'Failed to update user': 'server.failed_update_user',
  'Checkout successful': 'server.checkout_successful',
  'Valid case id is required': 'server.valid_case_id_required',
  'groupId is required': 'server.group_id_required',
  'service_type and horse_id are required': 'server.service_horse_required',
  'text_key and path are required': 'server.textkey_path_required',
  'path or permission_key already exists': 'server.path_or_permission_exists',
  'template_key already exists': 'server.template_key_exists',
  'معرّف خيل غير صالح': 'server.invalid_horse_id',
  'الحذف النهائي متاح لمدير النظام فقط': 'server.hard_delete_admin_only',
  Unauthorized: 'server.unauthorized',
  Forbidden: 'server.forbidden',
  'Access denied': 'server.access_denied',
  'No token provided': 'server.no_token',
  'Invalid token': 'server.invalid_token',
};

export function localizeServerMessage(raw) {
  if (!raw || typeof raw !== 'string') return raw;
  const key = MAP[raw] || MAP[raw.trim()];
  if (key && i18n.exists(key)) return i18n.t(key);
  return raw;
}

export default localizeServerMessage;
